/*eslint-disable*/
import Flickity from 'flickity'

export default carousel => {
  $(window).load(() => {

    const slideshow = carousel.querySelector('.js-included-slideshow')
    const rightArrow = carousel.querySelector('.js-bundle-items-left')
    const leftArrow = carousel.querySelector('.js-bundle-items-right')
    if (slideshow) {
      const flkty = new Flickity(slideshow, {
        contain: true,
        prevNextButtons: false,
        autoPlay: false,
        imagesLoaded: true,
        groupCells: 10,
        pageDots: false
      })

      flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
      flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

      setTimeout(() => {
        flkty.resize()
        $('#bundle-items').removeClass('transparent')
      }, 1500)

      rightArrow.addEventListener('click', () => {
        flkty.previous()
      })

      leftArrow.addEventListener('click', () => {
        flkty.next()
      })
    }
    $(slideshow).find('.flickity-viewport').addClass('shadow-sides').css({ 'width': '100vw', 'min-height': '100px' })
    $(slideshow).find('.flickity-slider').addClass('f aic')
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/bundle-items-slider.js